import { render, staticRenderFns } from "./turmaCard.vue?vue&type=template&id=18240ebe&scoped=true"
import script from "./turmaCard.vue?vue&type=script&lang=js"
export * from "./turmaCard.vue?vue&type=script&lang=js"
import style0 from "./turmaCard.vue?vue&type=style&index=0&id=18240ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18240ebe",
  null
  
)

export default component.exports